/**
 * Shared AG Grid defaultColDef for floating text filters (retail-portal pattern).
 */
export { DATE_COLUMN_FILTER_PARAMS, withDateColumnFilter } from './filterUtils';

export const SEARCH_TEXT_FILTER_PARAMS = {
  filterOptions: [
    {
      displayKey: 'searchtext',
      displayName: 'Search Text',
      predicate: ([filterValue], cellValue) => {
        if (filterValue == null || filterValue === '') return true;
        if (cellValue == null) return false;
        return String(cellValue)
          .toLowerCase()
          .includes(String(filterValue).toLowerCase());
      },
      numberOfInputs: 1,
    },
  ],
  maxNumConditions: 1,
  buttons: ['clear'],
  closeOnApply: true,
};

export const getDefaultColDef = (overrides = {}) => ({
  flex: 1,
  minWidth: 150,
  floatingFilter: true,
  filter: 'agTextColumnFilter',
  filterParams: SEARCH_TEXT_FILTER_PARAMS,
  // Avoid async cell-type inference delaying filterActive / header highlight (SSRM).
  cellDataType: false,
  resizable: true,
  sortable: true,
  menuTabs: ['generalMenuTab', 'columnsMenuTab'],
  ...overrides,
});

export default getDefaultColDef;



// WEBPACK FOOTER //
// ./src/components/grid/defaultColDef.js